// Copyright 2024 - Hewlett Packard Enterprise Company
/* eslint-disable import/prefer-default-export */
import { DEV_AUTHORITY_URL, OIDC_AUTHORITY } from '../constants/authConst';

export function isDevEnvAuth() {
  return OIDC_AUTHORITY === DEV_AUTHORITY_URL;
}

function sessionKeyStore() {
  let sessionKey = '';
  return {
    get: () => sessionKey,
    set: key => {
      if (sessionKey === '') {
        sessionKey = key;
      }
    },
  };
}

export const sessionKey = sessionKeyStore();
